import { render } from "./NewDepartement.vue?vue&type=template&id=39cd3b8a"
import script from "./NewDepartement.vue?vue&type=script&lang=js"
export * from "./NewDepartement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__